import React from "react";
import TnCard from "../components/TnCard";
import { TnSkeletonRows } from "../components/TnSkeleton";
import { clickableProps } from "../components/clickable";

/*
Block 3 - GET dashboard/team-velocity/

`role` is always null from this endpoint (no data source exists for it), so the
role line is rendered conditionally. It must never go through a template
literal, which would print the string "null".

Rows are one per service center central (`handler_id`); each row's `filters`
narrows the case list to the cases that handler closed in the period.
*/
const TeamVelocitySection = function (props) {
  const { resource, activeFilterId, onSelectFilter } = props;
  const handlers = (resource.data && resource.data.handlers) || [];

  return (
    <TnCard
      title="Team velocity"
      className="tn-velocity"
      loading={resource.loading}
      hasLoadedOnce={resource.hasLoadedOnce}
      error={resource.error}
      onRetry={resource.reload}
      empty={!resource.loading && !resource.error && handlers.length === 0}
      emptyText="No completed cases in this period."
      skeleton={<TnSkeletonRows n={3} />}
    >
      <ul className="tn-velocity-list">
        {handlers.map(function (handler, index) {
          const hasId =
            handler.handler_id !== null && handler.handler_id !== undefined;
          const clickable = !!(onSelectFilter && hasId && handler.filters);
          const id = "velocity:" + handler.handler_id;
          const active = clickable && activeFilterId === id;
          return (
            <li
              className={
                "tn-velocity-row" +
                (clickable ? " tn-clickable" : "") +
                (active ? " tn-clickable-active" : "")
              }
              key={hasId ? handler.handler_id : handler.handler || index}
              {...clickableProps(
                clickable
                  ? function () {
                      onSelectFilter(id);
                    }
                  : null,
                active
              )}
            >
              <div className="tn-velocity-who">
                <span className="tn-velocity-name">
                  {handler.handler || "—"}
                </span>
                {handler.role ? (
                  <span className="tn-velocity-role">{handler.role}</span>
                ) : null}
              </div>
              <div className="tn-velocity-figures">
                <span className="tn-velocity-done">
                  {handler.done === null || handler.done === undefined
                    ? "—"
                    : handler.done}
                </span>
                {handler.avg_days === null || handler.avg_days === undefined ? null : (
                  <span className="tn-velocity-avg">
                    {handler.avg_days}d avg
                  </span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </TnCard>
  );
};

export default TeamVelocitySection;
